export function compactTechnicalId(value?: string | null): string {
  if (!value) return 'n/a'
  if (value.length <= 22) return value

  if (value.startsWith('ledger-entry:')) {
    const parts = value.split(':')
    const last = parts.at(-1) ?? value
    const sale = parts.find((part) => part.startsWith('sale_') || part.startsWith('funnel'))
    return sale ? `ledger:${compactTechnicalId(sale)}:${last}` : `ledger:...:${last}`
  }

  if (value.startsWith('funnel:')) {
    const parts = value.split(':')
    const origin = parts[1]
    const offer = parts.at(-1)
    return origin && offer
      ? `funnel:${compactTechnicalId(origin)}:${compactTechnicalId(offer)}`
      : 'funnel:...'
  }

  const uuidMatch = value.match(
    /^([0-9a-f]{8})-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-([0-9a-f]{12})$/i,
  )
  if (uuidMatch) {
    const head = uuidMatch[1] ?? value.slice(0, 8)
    const tail = uuidMatch[2] ?? value.slice(-12)
    return `${head}...${tail.slice(-6)}`
  }

  if (value.startsWith('sale_')) {
    return `${value.slice(0, 10)}...${value.slice(-6)}`
  }

  return `${value.slice(0, 12)}...${value.slice(-8)}`
}
